// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"048a3b2b","292":"f420c9a9","453":"edd102e0","475":"448c7c99","575":"fa25edf5","582":"41690811","593":"ce318153","652":"d28d0638","823":"299ac23b","859":"a5c55473"}[chunkId] + ".chunk.js";
};